// extracted by mini-css-extract-plugin
module.exports = {"light-text-color":"#fff","dark-text-color":"#334155","default-placeholder-color":"#e2e8f0"};